export enum MatTableIconTypeEnum {
  VIDEO_PURCHASE_ORDER_TYPE = 1,
  VIDEO_STATUS_ICON = 2,
  EXPENDITURE_STATUS_ICON = 3
}
